<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <tsny-modal
      :modal-id="modalId"
      :modal-title="'Edit Course Relationship'"
      :submit-button-text="'UPDATE'"
      :submit-disabled="invalid"
      :reset-modal="resetModal"
      :submit-modal="updateCourseRelationship"
    >
      <b-row class="mb-4">
        <b-col>
          <b-text-input-validated
            v-model="tutorEmail"
            type="email"
            rules="required|email"
            :data-list="tutors"
            label="Tutor Email"
            name="tutor email"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          ><p class="tsny_status-text" v-if="updateCourseRelationshipError">
            An error occurred updating the course relationship
          </p></b-col
        >
      </b-row>
    </tsny-modal>
  </ValidationObserver>
</template>

<script>
import TsnyModal from "../TsnyModal";
import CourseRelationshipRestService from "../../services/rest/services/CourseRelationshipRestService";
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../FormInputs/BTextInputValidated";
export default {
  name: "UpdateCourseRelationship",
  components: { TsnyModal, ValidationObserver, BTextInputValidated },
  props: {
    relationship: {
      type: Object,
      default: null
    },
    tutors: {
      type: Array,
      default: null
    }
  },
  data: function() {
    return {
      modalId: "updateCourseRelationshipModal",
      tutorEmail: null,
      updateCourseRelationshipError: null
    };
  },
  methods: {
    resetModal() {
      this.tutorEmail = this.relationship.tutorEmail;
      this.updateCourseRelationshipError = null;
    },
    async updateCourseRelationship(bvModalEvent) {
      bvModalEvent.preventDefault();

      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.createCourseRelationshipError = false;

      if (!$comp.date) {
        $comp.startTime = null;
        $comp.endTime = null;
      }

      let relationship = $comp.relationship;

      return CourseRelationshipRestService.updateCourseRelationship({
        _id: relationship._id,
        tutorEmail: $comp.tutorEmail
      })
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          console.log(err);
          $comp.updateCourseRelationshipError = true;
        });
    }
  }
};
</script>

<style scoped></style>
